// eslint-disable-next-line
import React, { Fragment } from "react";
import { withRouter } from "react-router-dom";
import awesomePhoneNumber from "awesome-phonenumber";
import HeaderComponent from "../../helper/Navigationhelper";
import Mobilemenu from "../layouts/Mobilemenu";
import Menu from "./Menu";
import classNames from "classnames";
import BusinessLink from './BusinessLink'


class Headerfour extends HeaderComponent {
  // eslint-disable-next-line
  constructor(props) {
    super(props);
  }
  state = {
    backgroundColor: 'transparent'
  }

  listenScrollEvent = e => {
    if (window.scrollY > 100) {
      this.setState({ backgroundColor: '#1d2228' })
      // this.setState({ backgroundColor: '#1f1d1f' })
      // this.setState({ backgroundColor: `${this.props.themeColor}` })
    } else {
      this.setState({ backgroundColor: 'transparent' })
    }
  }

  componentDidMount() {
    window.addEventListener('scroll', this.listenScrollEvent)
  }

  render() {

    const logoDefaultTempUrl = `${window.location.origin}/assets/default/default-logo.png`

    const logoUrl = this?.props?.logo || logoDefaultTempUrl
    const business_name = this?.props?.businessName
    const storeLocation = this?.props?.storeLocation
    const storeAddress = `${storeLocation?.street}, ${storeLocation?.city}, ${storeLocation?.state_province} ${storeLocation?.zip_postal_code}`
    const storePhone = this?.props?.storePhone
    const regionCode = "CA"
    const phNum = awesomePhoneNumber(storePhone.replace("+1"), regionCode)
    const phoneresult = phNum.getNumber("national")
    const bannerInfo = this?.props?.bannerInfo
    const businessSlugName = this?.props?.match?.params?.slugname
    const locationList = this?.props?.contactInfo
    const customPage = this?.props?.customPage
    const newCustomPage = this?.props?.newCustomPage
    const newCustomPage2 = this?.props?.newCustomPage2
    const newCustomPage3 = this?.props?.newCustomPage3
    const isCateringMenu = this?.props?.isCateringMenu
    const isSpecialMenu = this?.props?.isSpecialMenu
    const isShowExtraPage = this?.props?.isShowExtraPage
    const websiteFooterColor = this?.props?.websiteFooterColor
    const websiteHeaderColor = this?.props?.hideHeaderBackground ? 'transparent' : this?.props?.websiteFooterColor
    const websiteBackgroundColor = this?.props?.websiteBackgroundColor
    const websiteTextColor = this?.props?.websiteTextColor
    const socialMedia = this?.props?.socialMedia
    const jobsPageShow = this?.props?.jobsPageShow
    const contactSection = this?.props?.contactSection
    const businessId = this?.props?.businessId
    const showGalleryPage = this?.props?.showGalleryPage
    const faqsPageShow = this?.props?.faqsPageShow

    return (
      <Fragment>
        <aside
          className={classNames("main-aside", { open: this.state.navmethod })}
          style={{ backgroundColor: websiteFooterColor }}
        >
          <Mobilemenu
            logo={logoUrl}
            businessName={business_name}
            locationList={locationList}
            customPage={customPage}
            newCustomPage={newCustomPage}
            isCateringMenu={isCateringMenu}
            isSpecialMenu={isSpecialMenu}
            isShowExtraPage={isShowExtraPage}
            socialMedia={socialMedia}
            storeAddress={storeAddress}
            bannerInfo={bannerInfo}
            newCustomPage2={newCustomPage2}
            newCustomPage3={newCustomPage3}
            websiteBackgroundColor={websiteBackgroundColor}
            websiteTextColor={websiteTextColor}
            jobsPageShow={jobsPageShow}
            faqsPageShow={faqsPageShow}
            contactSection={contactSection}
            businessId={businessId}
            showGalleryPage={showGalleryPage}
          />
        </aside>
        <div className="aside-overlay aside-trigger" onClick={this.toggleNav} />
        <div className="main-header-secondary">
          <div className="container">
            <div className="header-location">
              <a href={`http://www.google.com/maps/search/${storeAddress}`} target="_blank" rel="noreferrer">
                <span>{storeAddress}</span>
              </a>
              <br class="mobile-break" />
              <a href={`tel:${storePhone}`} rel="noreferrer">{phoneresult}</a>
            </div>
          </div>
        </div>
        <header className="main-header header-1 header-4 header-light header-absolute" style={{ paddingTop: 5, paddingBottom: 5, position: 'sticky', top: 0, backgroundColor: websiteHeaderColor }}>
          <div className="container menu-bar">
            <nav className="navbar">
              <BusinessLink className="navbar-brand" to="/">
                {" "}
                <img
                  className="logo-img"
                  src={logoUrl}
                  alt={business_name}
                  title={business_name}
                />{" "}
              </BusinessLink>
              <div>
                <Menu
                  businessSlug={businessSlugName}
                  locationList={locationList}
                  customPage={customPage}
                  newCustomPage={newCustomPage}
                  isCateringMenu={isCateringMenu}
                  isSpecialMenu={isSpecialMenu}
                  isShowExtraPage={isShowExtraPage}
                  bannerInfo={bannerInfo}
                  newCustomPage2={newCustomPage2}
                  newCustomPage3={newCustomPage3}
                  websiteBackgroundColor={websiteBackgroundColor}
                  websiteTextColor={websiteTextColor}
                  showGalleryPage={showGalleryPage}
                />
                <div className="header-controls">
                  <div
                    className="aside-toggler aside-trigger"
                    onClick={this.toggleNav}
                  >
                    <span />
                    <span />
                    <span />
                  </div>
                </div>
              </div>
            </nav>
          </div>
        </header>
      </Fragment>
    );
  }
}

export default withRouter(Headerfour);
